const splitTextToEvenLines = (text) => {
    // 500px < 1024px, 700px above
    const lineWidth = window.innerWidth < 1024 ? 30 : 50;

    const totalTextChars = text ? text.length : 0;

    if (totalTextChars > lineWidth) {
        // we introduce a unique splitting character ¶,
        // so that when we join again we don't have to remember which
        // was the word delimiting character: .,;- and so on
        const words = text.replace(/[.,; 、]/g, (m) => `${m}¶`).split('¶');

        let delta;
        let previousDelta;
        let nextWord;
        const firstLine = [];
        const err = 3;
        do {
            previousDelta = firstLine.join('').length - words.join('').length;
            [nextWord] = words;
            delta = [...firstLine, nextWord].join('').length - words.slice(1).join('').length;
            if (Math.abs(delta) - err < Math.abs(previousDelta)) {
                firstLine.push(words.splice(0, 1)[0]);
            } else break;
        } while (true);
        return [firstLine.join(''), words.join('')];
    }

    return [text];
};

export default splitTextToEvenLines;
